<template>
  <Scaffold :menus="menus" />
</template>
<script>
import Scaffold from "@/components/layout/Scaffold.vue";

export default {
  components: {
    Scaffold,
  },
  data() {
    return {
      menus: [
        {
          name: "业绩数据",
          path: "/area-manager/dashboard",
          icon: {
            active: require("@/assets/icons/tab-dashboard-active.svg"),
            inactive: require("@/assets/icons/tab-dashboard-inactive.svg"),
          },
        },
        {
          name: "店铺管理",
          path: "/area-manager/stores",
          icon: {
            active: require("@/assets/icons/tab-stores-active.svg"),
            inactive: require("@/assets/icons/tab-stores-inactive.svg"),
          },
        },
        {
          name: "全部订单",
          path: "/area-manager/orders",
          icon: {
            active: require("@/assets/icons/tab-orders-active.svg"),
            inactive: require("@/assets/icons/tab-orders-inactive.svg"),
          },
        },
        {
          name: "我的",
          path: "/area-manager/my",
          icon: {
            active: require("@/assets/icons/tab-mine-active.svg"),
            inactive: require("@/assets/icons/tab-mine-inactive.svg"),
          },
        },
      ],
    };
  },
};
</script>
